var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteriaR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1891_5685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1891_5685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 13.7999V16.5732C11.4 16.7077 11.4583 16.7874 11.575 16.8124C11.6916 16.8374 11.775 16.7916 11.825 16.6749L13.525 12.6249C13.5916 12.4761 13.5824 12.3347 13.4972 12.2008C13.412 12.0669 13.2879 11.9999 13.125 11.9999H12.6V9.2266C12.6 9.09214 12.5416 9.0124 12.425 8.9874C12.3083 8.9624 12.225 9.00824 12.175 9.1249L10.475 13.1749C10.4083 13.3237 10.4175 13.4651 10.5027 13.599C10.5879 13.7329 10.712 13.7999 10.875 13.7999H11.4ZM8.39995 21.5999C8.05995 21.5999 7.77495 21.4849 7.54495 21.2549C7.31495 21.0249 7.19995 20.7399 7.19995 20.3999V5.3999C7.19995 5.0599 7.31495 4.7749 7.54495 4.5449C7.77495 4.3149 8.05995 4.1999 8.39995 4.1999H10.1972V3.2999C10.1972 3.0449 10.2833 2.83115 10.4556 2.65865C10.6278 2.48615 10.8412 2.3999 11.0958 2.3999H12.8931C13.1477 2.3999 13.3615 2.48615 13.5345 2.65865C13.7076 2.83115 13.7941 3.0449 13.7941 3.2999V4.1999H15.6C15.94 4.1999 16.225 4.3149 16.455 4.5449C16.685 4.7749 16.8 5.0599 16.8 5.3999V20.3999C16.8 20.7399 16.685 21.0249 16.455 21.2549C16.225 21.4849 15.94 21.5999 15.6 21.5999H8.39995ZM8.99995 19.7999H15V5.9999H8.99995V19.7999Z",
    fill: "#D3135A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteriaR);
export default __webpack_public_path__ + "static/media/batteria_r.7caac1c86593a7a1073678064402bc0c.svg";
export { ForwardRef as ReactComponent };